<template>
<box-view class="teamporaryorder container-fluid px-0 mb-0 font-weight-bold" title="Đơn hàng nháp" @close="close">
    <!-- Empty -->
    <div v-if="orders.length === 0" class="text-center text-muted py-5">
        Chưa có đơn tạm
    </div>

    <!-- Order list -->
    <div class="row gx-2 py-2 px-4 gy-2">
        <div v-for="order in orders" :key="order.id" class="col-12 col-md-6 py-2">
            <div class="card mb-3 shadow-sm order-card h-100">
                <div class="card-body">

                    <!-- Top -->
                    <div class="d-flex justify-content-between mb-1">
                        <div class="fw-bold">#{{ order.id }}</div>
                        <div class="text-muted small">
                            {{ formatTime(order.createdAt) }}
                        </div>
                    </div>

                    <!-- Creator Info -->
                    <div class="d-flex align-items-center mb-1">
                        <span class="badge bg-info text-white">
                            <i class="fas fa-user-edit me-1"></i>
                            {{ order.userName || 'Không rõ' }}
                        </span>
                    </div>

                    <!-- Amount -->
                    <div class="d-flex justify-content-between amount-box">
                        <span>Tổng tiền đơn</span>
                        <span class="fw-bold text-danger">
                            {{ (order.totalBill || 0).toLocaleString() }}₫
                        </span>
                    </div>

                    <!-- Customer Info -->
                    <div class="customer-box mt-2 p-2 rounded bg-light">
                        <div class="d-flex justify-content-between align-items-center mb-1">
                            <div class="fw-bold">
                                <i class="fas fa-user me-1"></i>
                                {{ order.customer?.name || 'Khách lẻ' }}
                            </div>
                            <div class="text-muted">
                                SDT: {{ order.customer?.phone || '—' }}
                            </div>
                        </div>

                        <div class="small text-muted">
                            <div class="mb-1 d-flex">
                                <i class="fas fa-map-marker-alt me-1"></i>
                                {{ order.customer?.address || '—' }}
                            </div>
                            <div class="d-flex">
                                <i class="fas fa-sticky-note me-1"></i>
                                {{ order.customer?.note || '—' }}
                            </div>
                        </div>
                    </div>

                    <!-- Actions -->
                    <div class="d-flex gap-2 mt-3">
                        <van-button block size="small" type="primary" @click="restore(order)">
                            Tiếp tục bán
                        </van-button>

                        <van-button block size="small" type="danger" plain @click="remove(order.id)">
                            Xóa
                        </van-button>
                    </div>

                </div>
            </div>
        </div>
    </div>

</box-view>
</template>

<script>
export default {
    props: {
        tempOrders: {
            type: Array,
            default: () => []
        }
    },
    computed: {
        orders() {
            // Filter invalid orders like original code did
            return this.tempOrders.filter(
                o => o && o.id && o.cart && o.cart.length > 0
            );
        }
    },
    methods: {
        formatTime(time) {
            return new Date(time).toLocaleString();
        },
        remove(id) {
            this.$emit('delete-draft', id);
        },
        restore(order) {
            // Keep using localStorage for passing data to Home (navigation logic)
            // But we might also want to remove it from temp list?
            // The original logic kept it in tempOrders until explicitly deleted or verified.
            // Wait, original restore just pushed router, didn't delete.
            localStorage.setItem(
                'restoreOrder',
                JSON.stringify(order)
            );
            this.$emit('restore-draft', order); // Optional, for App to know
            this.$router.push('/');
        },
        close() {
            this.$router.back();
        },
    }
};
</script>
